import { Link, useNavigate } from 'react-router-dom';
import type { Category } from '../types';
import { ProgressBar } from './ProgressBar';

const ICON_EMOJI: Record<string, string> = {
  utensils: '🍜',
  'map-pin': '🛺',
  home: '🏠',
  tag: '🛍️',
  'heart-pulse': '💊',
  'file-badge': '📄',
  'message-circle': '💬',
  'chef-hat': '🍽️',
  siren: '🚨',
  wallet: '💵',
};

interface Props {
  category: Category;
}

export function CategoryCard({ category }: Props) {
  const navigate = useNavigate();
  const locked = !category.unlocked;

  const pct = category.phraseCount > 0
    ? Math.round((category.seenCount / category.phraseCount) * 100)
    : 0;
  const emoji = ICON_EMOJI[category.icon] ?? '✨';

  const inner = (
    <>
      <div className="category-card-icon" aria-hidden="true">{emoji}</div>
      <div className="category-card-name">{category.name}</div>
      <div className="category-card-meta">
        {category.seenCount} of {category.phraseCount} seen
        {category.masteredCount > 0 && ` · ${category.masteredCount} mastered`}
      </div>
      <ProgressBar value={pct} ariaLabel={`${category.name} progress`} />
      {locked && (
        <div className="lock-overlay">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
          <span>Upgrade</span>
        </div>
      )}
    </>
  );

  if (locked) {
    return (
      <button
        type="button"
        className="category-card category-card-locked"
        onClick={() => navigate('/upgrade')}
        aria-label={`${category.name} (locked — upgrade to unlock)`}
      >
        {inner}
      </button>
    );
  }
  return (
    <Link to={`/learn/${category.slug}`} className="category-card" aria-label={`Open ${category.name}`}>
      {inner}
    </Link>
  );
}
